import { createSelector } from '@reduxjs/toolkit';
import { type FeatureSelectorWithFallback } from '@store/storeTypes';
import { type RootState } from '@store/types';

import { type FeedbackState } from './slice';

const emptyState: FeedbackState = {
  lastCSATShownTimestamp: null,
};

// Base selector
export const selectFeedbackState: FeatureSelectorWithFallback<FeedbackState, typeof emptyState> = (
  state: RootState,
) => state.feedback || emptyState;

// Basic selector
export const selectLastCSATShownTimestamp = createSelector(
  [selectFeedbackState],
  state => state.lastCSATShownTimestamp,
);

// Computed selector for timing logic
const FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;

export const selectShouldShowCSAT = createSelector([selectLastCSATShownTimestamp], timestamp => {
  if (!timestamp) return true; // First time - no timestamp exists
  const daysSince = Date.now() - timestamp;
  return daysSince >= FOURTEEN_DAYS_MS;
});
